import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { mxSharedApi } from "./api";
import { queryClient } from "@shared/api/queries/queryClient";
import { useToast } from "@shared/hooks/use-toast";

export const useGetNotes = (id: string, type: string) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.shared.notesList(id, type),
    () => mxSharedApi.getNotes(id, type)
  );
};

export const useCreateNote = () => {
      const { toast } = useToast();
  return useSmartMutation((payload: any) => mxSharedApi.createNote(payload), {
    onSuccess: () => {
      toast({
        title: "Note created successfully!",
        variant: "default",
      });

      const key = QueryKeyFactory.module.mx.shared.notesList().slice(0, 4);

      queryClient.invalidateQueries({
        queryKey: key,
      });
    },
    onError: (error: Error) => {
      toast({
        title: `Failed to create a note: ${error.message}`,
        variant: "destructive",
      });
    },
  });
};

export const useGetActivityLog = (id: string, type: string) => {
  return useSmartQuery(
    QueryKeyFactory.module.mx.shared.activityLogList(id, type),
    () => mxSharedApi.getActivityLog(id, type)
  );
};

